import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import LocationParentsView from './ui/LocationParentsView';
import PaginationButtons from './PaginationButtons';
import SortTable from './ui/SortTable';

import config from './../config';
import helpers from './../lib/helpers';

class SagnirPersonList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			nextUrl: null,
			previousUrl: null,
			resultCount: 0,
			loading: true,
			lastParams: '',
			initialized: false
		};
	}

	componentDidMount() {
		if (this.props.searchParams || this.props.personId || this.props.mentionId) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.searchParams != prevProps.searchParams || 
			this.props.personId != prevProps.personId ||
			this.props.mentionId != prevProps.mentionId) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			loading: true,
			data: null
		});

		let urlParams = [];

		if (this.props.personId) {
			urlParams.push('person='+this.props.personId)
		}

		if (this.props.mentionId) {
			urlParams.push('person_mention='+this.props.mentionId)
		}

		if (this.props.searchParams) {
			let params = helpers.parseSearchParams(this.props.searchParams)

			if (params.sida) {
				urlParams.push('limit='+config.pageSize);
				urlParams.push('offset='+(config.pageSize*(params.sida-1)))
			}

			if (params.rodun) {
				urlParams.push('order='+params.rodun)
			}
		}

		helpers.fetch(config.apiRoot+'/api/folklore/persons/?'+urlParams.join('&'), (json) => {
			if (json) {
				this.setState({
					data: json.results,
					nextUrl: json.next,
					previousUrl: json.previous,
					resultCount: json.count
				});

				if (this.props.onResponse) {
					this.props.onResponse(json.results);
				}
			}
			this.setState({
				loading: false
			});
		});
	}

	render() {
		return (
			<div className={'position-relative '+(this.props.className || '')+(this.state.loading ? ' loading' : '')}>
				<LoadingBar />
				{
					this.props.enableFilter &&
					<ListFilter filters={[
						{
							label: 'Nafn',
							paramName: 'nafn',
							type: 'text'
						}
					]}
					onFilter={(event) => {
						this.props.history.push(this.props.history.location.pathname+helpers.updateSearchParams(this.props.searchParams, event));
					}} />
				}
				{
					this.props.children
				}
				{
					this.state.data && this.state.data.length > 0 &&
					<React.Fragment>
						<SortTable searchParams={this.props.searchParams}
							headers={[
								{
									label: 'Titill',
									sortValue: 'folklore__name',
									width: '50%'
								},
								{
									label: 'Tegund',
									sortValue: 'folklore__type'
								},
								{
									label: 'Hlutverk',
									sortValue: 'type'
								},
								{
									label: 'Heimild'
								}
							]}
						>
							{
								this.state.data.map((item, index) => <tr key={index}>
									<td>
										<Link to={helpers.routerUrls['sagnir_aevintyri']+item.folklore.id}>
											{
												item.folklore.name
											}
										</Link>
									</td>

									<td>{
										helpers.metadataList(item.folklore.type, helpers.routerUrls['tjodfraedi_leit'], 'id', 'name', 'form')
									}</td>

									<td>
										{
											helpers.sagnirRelationTypes[item.type] || item.type
										}
									</td>

									<td>{item.folklore.source}</td>
								</tr>)
							}
						</SortTable>
						{
							this.state.resultCount > config.pageSize &&
							<PaginationButtons resultCount={this.state.resultCount}
								previousUrl={this.state.previousUrl}
								nextUrl={this.state.nextUrl} />
						}
					</React.Fragment>
				}
			</div>
		)
	}
}

export default withRouter(SagnirPersonList);
